import {
  NameForm as NameFormQnr,
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '@getpopsure/qnr-framework';
import { useSafeTranslation } from 'shared/i18n';

interface Name {
  firstName: string;
  lastName: string;
}

export const NameForm = <Questionnaire extends QuestionnaireQuestions>({
  value,
  ...rest
}: QuestionnaireFormProps<Questionnaire>) => {
  const { t } = useSafeTranslation();

  return (
    <NameFormQnr
      {...rest}
      value={value as Name | undefined}
      firstNameLabel={t('qnrf.forms.name.firstname.placeholder', 'First name')}
      lastNameLabel={t('qnrf.forms.name.lastname.placeholder', 'Last name')}
    />
  );
};
